<template>
  <div>
    <TeJobIndexCover />
    <TeJobIndexWhat />
    <TeJobAbout>
      <template #title>
        テックアカデミーの
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          プロダクト開発における「わからない」を無くしたい。
          <br class="hidden md:block">
          テックアカデミーのメンターはリモートで悩める受講生をサポートします。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
      </template>
    </TeJobAbout>
    <TeJobTarget />

    <TeJobMessage>
      <template #mentoringText>
        1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
        <br class="hidden md:block">
        時にはペアプログラミングなどのサポートをしていただきます。
        <br class="hidden md:block">
        マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
      </template>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />
    <TeJobMentor>
      <template #mentorOne>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-kimura.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Tomoaki Kimura"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Tomoaki Kimura<br><span class="co-display-14 mr-1 mt-3 inline-block bg-co-gray-300 p-1 px-2">Ruby/Ruby on Rails</span><span class="co-display-14 mr-1 mt-3 inline-block bg-co-gray-300 p-1 px-2">フロントエンド</span>
          </h4>
          <p>
            <span>前職は営業職という転職エンジニア。Rails歴は6年目。</span>
            <span>業界未経験者を主軸に構成されるweb開発チームLize代表。</span>
            <span>最近では子供のプログラミング教育にも力を入れており、近隣の塾や英会話教室等で講師としても活動している。</span>
          </p>
        </div>
      </template>
      <template #mentorTwo>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-boumura.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Taisuke Boumura"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Taisuke Boumura<br><span class="co-display-14 mr-1 mt-3 inline-block bg-co-gray-300 p-1 px-2">Ruby/Ruby on Rails</span>
          </h4>
          <p>
            <span>大学で情報系を学びSI企業へ就職。その後複数回の転職でマネージャーやチームリーダーを経験し、現在はスタートアップでエンジニア担当。</span>
            <span>日本のIT水準を高めるべく未経験・学生など様々な方にプログラミングやシステム開発を経験してもらいたいため、テックアカデミーに参画しました。</span>
          </p>
        </div>
      </template>
    </TeJobMentor>
    <TeJobMentorSlider />
    <TeJobIndexFaq />
    <TeJobIndexEntry />
  </div>
</template>

<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import TeJobIndexCover from '~/components/Te/TeJob/Index/TeJobIndexCover.vue'
import TeJobIndexWhat from '~/components/Te/TeJob/Index/TeJobIndexWhat.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobIndexFaq from '~/components/Te/TeJob/Index/TeJobIndexFaq.vue'
import TeJobIndexEntry from '~/components/Te/TeJob/Index/TeJobIndexEntry.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'

useJobHead()

useHead({
  title: 'プログラミング講師（メンター）募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするメンター（プログラミング講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'プログラミング講師（メンター）募集',
      twitterDescription:
        '受講生をサポートするメンター（プログラミング講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '/_nuxt/ogp/og-image-mentor-entry.jpg',
      ogTitle: 'プログラミング講師（メンター）募集',
      ogDescription:
        '受講生をサポートするメンター（プログラミング講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/job',
      ogImage: '/_nuxt/ogp/og-image-mentor-entry.jpg',
    }),
  ],
  bodyAttrs: {
    class: 'bg-co-gray-200'
  },
})
</script>
